const parseAmount = (value) => {
    if (typeof value === "number") {
        return Number.isFinite(value) ? value : 0;
    }

    if (typeof value === "string") {
        const cleaned = value.replace(/,/g, "").replace(/[^0-9.-]/g, "");
        const parsed = parseFloat(cleaned);
        return Number.isFinite(parsed) ? parsed : 0;
    }

    const parsed = parseFloat(value || 0);
    return Number.isFinite(parsed) ? parsed : 0;
};

export const formatAmount = (value, options = {}) => {
    const {
        locale = "en-IN",
        minimumFractionDigits = 2,
        maximumFractionDigits = 2,
    } = options;

    return parseAmount(value).toLocaleString(locale, {
        minimumFractionDigits,
        maximumFractionDigits,
    });
};

export const formatCurrency = (value, currency = "Rs.", options = {}) => {
    const { space = false, ...amountOptions } = options;
    const separator = space ? " " : "";
    return `${currency}${separator}${formatAmount(value, amountOptions)}`;
};
